import React, { useEffect, useState } from "react";
import AttendanceNew from "../HomeComponents/AttendanceNew";
import FullEmployeeListWithAttendance from "../HomeComponents/FullEmployeeListWithAttendance";
import JobStatus from "../HomeComponents/JobStatus";
import OnLeave from "../HomeComponents/OnLeave";
import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";

const AttendanceBubbleChart = () => {
  const [onDutyCount, setOnDutyCount] = useState(0);
  const [leaveCounts, setLeaveCounts] = useState(null);
  const [absenteesCount, setAbsenteesCount] = useState(0);
  const [onLeaveCount, setOnLeaveCount] = useState(0);
  console.log("in parent bubble onDutyCount", onDutyCount);


  const handleOnLeaveCount = (onLeaveCnt) => {
    setOnLeaveCount(onLeaveCnt);
    console.log(onLeaveCnt);
  };

  const handleOnDutyCount = (onLeaveCnt) => {
    console.log("onduty", onLeaveCnt);

    setOnDutyCount(onLeaveCnt);
  };


  const handleAbsenteesCount = (count) => {
    console.log("count:", count);
    // setAbsenteesCount(count);
  };

  const {
    onDuty = 0,
    vacation = 0,
    sickLeave = 0,
    dayOff = 0,
    wfh = 0,
    businessTrip = 0,
  } = leaveCounts || {};

  const stats = [
    { label: "On-Duty", value: onDuty, color: "bg-blue-500" },
    { label: "Absentees", value: sickLeave + dayOff, color: "bg-cyan-400" },
    // { label: "Absentees", value: absenteesCount, color: "bg-cyan-400" },
    { label: "On-Leave", value: vacation, color: "bg-green-400" },
  ];

  const [showAbsenteesPopup, setShowAbsenteesPopup] = useState(false);
  const [showOnDutyPopup, setShowOnDutyPopup] = useState(false);
  const [showOnLeavePopup, setShowOnLeavePopup] = useState(false);

  const onAbsenteesClick = () => {
    setShowAbsenteesPopup(true);
  };

  const onOnDutyClick = () => {
    setShowOnDutyPopup(true);
  };

  const onOnLeaveClick = () => {
    console.log("onleave click");
    setShowOnLeavePopup(true);
  };

  useEffect(()=>{
fetchAbsentAttendanceData()
fetchOnDutyAttendanceData()
fetchOnLeaveAttendanceData()
  },[])
  
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const fetchAbsentAttendanceData = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/CpaysCount/${companyCode}/ATTENDANCEDAILY_ABS/-/-`
      );

      if (response.status === 200) {
        // setAttendanceApiData(response.data);
        console.log("attendance api data", response.data);
        // onAbsentCountChange(response?.data[0].Cnt);
        setAbsenteesCount(response?.data[0].Cnt)
        // setShowLoader(false);
      }
    } catch (error) {
      console.log("fetchAttendanceDataErr", error);
      // setShowLoader(false);
    }
  };

  const fetchOnDutyAttendanceData = async () => {
    try {
      const response = await axios.get(
         `${base_url}/api/CpaysCount/${companyCode}/ATTENDANCEDAILY/-/-`
      );

      if (response.status === 200) {
        // setAttendanceApiData(response.data);
        console.log("attendance api data", response.data);
        // onAbsentCountChange(response?.data[0].Cnt);
        setOnDutyCount(response?.data[0].Cnt)
        // setShowLoader(false);
      }
    } catch (error) {
      console.log("fetchAttendanceDataErr", error);
      // setShowLoader(false);
    }
  };

  const fetchOnLeaveAttendanceData = async () => {
    try {
      const response = await axios.get(
                 `${base_url}/api/CpaysCount/${companyCode}/ATTENDANCEDAILY_LEAVE/-/-`

      );

      if (response.status === 200) {
        // setAttendanceApiData(response.data);
        console.log("attendance api data", response.data);
        // onAbsentCountChange(response?.data[0].Cnt);
        setOnLeaveCount(response?.data[0].Cnt)
        // setShowLoader(false);
      }
    } catch (error) {
      console.log("fetchAttendanceDataErr", error);
      // setShowLoader(false);
    }
  };

  return (
    <div className="relative w-[300px] h-[300px] mx-auto">
      {/* On-Duty */}
      <div
        onClick={onOnDutyClick}
        className={`cursor-pointer hover:shadown-md absolute ${stats[0].color} text-white rounded-full flex items-center justify-center text-center shadow-md`}
        style={{
          width: "140px",
          height: "140px",
          top: "60px",
          left: "0px",
          zIndex: 30,
        }}
      >
        <div>
          <div className="text-2xl font-bold">{onDutyCount}</div>
          <div className="text-sm">{stats[0].label}</div>
        </div>
      </div>
      {/* Absentees */}
      <div
        onClick={onAbsenteesClick}
        className={`cursor-pointer hover:shadown-md absolute ${stats[1].color} text-white rounded-full flex items-center justify-center text-center shadow-md`}
        style={{
          width: "100px",
          height: "100px",
          top: "20px",
          left: "120px",
          zIndex: 20,
        }}
      >
        <div>
          <div className="text-xl font-bold">{absenteesCount}</div>
          <div className="text-sm">{stats[1].label}</div>
        </div>
      </div>
      {/* On-Leave */}
      <div
        onClick={onOnLeaveClick}
        className={`hover:shadown-md absolute ${stats[2].color} text-white rounded-full flex items-center justify-center text-center shadow-md`}
        style={{
          width: "100px",
          height: "100px",
          top: "160px",
          left: "100px",
          zIndex: 10,
        }}
      >
        <div>
          <div className="text-lg font-bold">{onLeaveCount}</div>
          <div className="text-sm">{stats[2].label}</div>
        </div>
      </div>
      {showAbsenteesPopup && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
          <div className="relative w-full max-w-xl  bg-white rounded-2xl overflow-y-scroll hover:scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent p-1">
            {/* Close button at bottom */}
            <div className=" flex justify-between items-center mx-2 mt-4">
              <div>
                <h2 className="text-lg font-semibold text-gray-800 ml-4">
                  Absentees
                </h2>
              </div>
              <button
                className="text-3xl mr-4 text-black rounded transition"
                onClick={() => setShowAbsenteesPopup(false)}
              >
                &times;
              </button>
            </div>
            <div className="bg-white h-full">
              <AttendanceNew
                onAbsenteesCountChange={handleAbsenteesCount}
                onAbsentCountChange={handleAbsenteesCount}
              />
            </div>
          </div>
        </div>
      )}
      {showOnDutyPopup && (
        //         <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
        //           <div className="relative w-full max-w-xl  bg-white rounded-2xl overflow-y-scroll hover:scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent p-1">
        //             {/* Close button at bottom */}
        //             <div className="">
        //               <div className=" flex justify-between items-center">
        //                 <div></div>
        // <div className="relative">
        //   <button
        //     className="absolute top-2 right-2 z-10 text-3xl text-black"
        //     onClick={() => setShowOnDutyPopup(false)}
        //   >
        //     &times;
        //   </button>
        //   {/* modal content here */}
        // </div>
        //               </div>
        //               <div className="px-4 max-h-[450px] ">
        //                 <FullEmployeeListWithAttendance />
        //               </div>
        //             </div>
        //           </div>
        //         </div>
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
          <div className="relative w-full max-w-xl bg-white rounded-2xl overflow-y-scroll hover:scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent p-1 max-h-[50vh]">
            {/* Sticky Close Button */}
            <div className="flex  justify-between items-center">
              <h2 className="text-lg font-semibold text-gray-800 ml-4 p-2">
                On Duty
              </h2>

              <div className="sticky top-0 bg-white z-20 p-2 mr-4 flex justify-end">
                <button
                  className="text-3xl text-black"
                  onClick={() => setShowOnDutyPopup(false)}
                >
                  &times;
                </button>
              </div>
            </div>

            {/* Modal Content */}
            <div className="px-4 pb-4">
              <FullEmployeeListWithAttendance
                onDutyCountChange={handleOnDutyCount}
              />
            </div>
          </div>
        </div>
      )}
      {/* <div style={{ display: "none" }}>
        <JobStatus onDutyCountUpdate={(count) => setOnDutyCount(count)} />
      </div> */}
      <div>
        {/* <JobStatus
          onLeaveCountsUpdate={(counts) => {
            console.log("Leave counts:", counts);
            setLeaveCounts(counts);
            // { onDuty: 3, vacation: 1, sickLeave: 2, dayOff: 0, wfh: 4, businessTrip: 1 }
          }}
          onBirthdayCountUpdate={(birthdayCount) => {
            console.log("Birthday count:", birthdayCount);
          }}
        /> */}

        {showOnLeavePopup && (
          <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
            <div className="relative w-full max-w-xl  bg-white rounded-2xl overflow-y-scroll hover:scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent p-1">
              {/* Close button at bottom */}
              <div className=" flex justify-between items-center mx-2 mt-4">
                <div>
                  <h2 className="text-lg font-semibold text-gray-800 ml-4">
                    On Leave
                  </h2>
                </div>
                <button
                  className="text-3xl mr-4 text-black rounded transition"
                  onClick={() => setShowOnLeavePopup(false)}
                >
                  &times;
                </button>
              </div>
              <div className="bg-white h-full">
                <OnLeave onLeaveCountChange={handleOnLeaveCount} />
                {/* <FullEmployeeListWithAttendance /> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AttendanceBubbleChart;
